import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { companyIndustries, companySize, companyNew } from 'api/login';
import GlButton from '@/components/gl-button'; // 登录api
import { utilCookies } from '@/util/cookies'; // token操作
export default {
  components: {
    GlButton: GlButton
  },
  data: function data() {
    var str = utilCookies.getLanguage() || 'en';
    return {
      lang: str,
      ruleForm: {
        name: '',
        admin_name: '',
        email: '',
        industry: '',
        size: ''
      },
      industries: [],
      size: [],
      // 校验规则
      rules: {
        name: [{
          required: true,
          message: this.$t('login.19'),
          trigger: 'blur'
        }],
        admin_name: [{
          required: true,
          message: this.$t('login.20'),
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: this.$t('login.21'),
          trigger: 'blur'
        }],
        industry: [{
          required: true,
          message: this.$t('login.17'),
          trigger: 'change'
        }],
        size: [{
          required: true,
          message: this.$t('login.16'),
          trigger: 'change'
        }]
      },
      // 按钮loading
      loading: false
    };
  },
  created: function created() {
    this.init();
  },
  computed: {
    isClick: function isClick() {
      var _this$ruleForm = this.ruleForm,
        name = _this$ruleForm.name,
        admin_name = _this$ruleForm.admin_name,
        email = _this$ruleForm.email,
        industry = _this$ruleForm.industry,
        size = _this$ruleForm.size;
      var status = name && admin_name && email && industry && size;
      return status;
    }
  },
  methods: {
    init: function init() {
      var _this = this;
      // 行业
      companyIndustries().then(function (res) {
        _this.industries = res.data;
      });
      // 规模
      companySize().then(function (res) {
        _this.size = res.data;
      });
    },
    // 账号登录
    handleLogin: function handleLogin() {
      var _this2 = this;
      // 表单必填项验证
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.$ga.event('FHRSignup', 'click', 'CreateTeam', 13);
          _this2.loading = true;
          _this2.ruleForm.country_code = 'TH'; // 国家默认为泰国
          companyNew(_this2.ruleForm).then(function (res) {
            if (res && res.code === 1) {
              _this2.$router.push({
                path: '/register/success'
              });
            }
          }).finally(function () {
            _this2.loading = false;
          });
        }
      });
    }
  }
};